/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotMedia = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'MEDIA',
]);

export default [
  ...[
    getFilterWithCol(['FieldUploadRefsHorizontal', {
      name: 'media_image',
      label: null,
      accept: 'image/jpg,image/jpeg,image/png,image/svg+xml,image/webp',
      transformations: [
        // TODO Builder Media image compression
        ['GM', { command: 'compress', maxWidth: 2000 }],
        ['GM', { command: 'webp' }],
      ],
      listType: 'picture',
      uploadLabel: 'Upload Image',
      maxCount: 1,
    }], 12),
    getFilterWithCol(['FieldUploadRefsHorizontal', {
      name: 'media_video',
      label: null,
      accept: 'video/mp4',
      transformations: [
        // TODO Builder Media video compression (dont really have it)
        // ['GM', { command: 'compress', maxWidth: 1200 }],
      ],
      listType: 'picture',
      uploadLabel: 'Upload Video',
      maxCount: 1,
    }], 12),
    getFilterWithCol(['FieldRadio', {
      name: 'media_objectFit',
      label: null,
      initialValue: 'NORMAL',
      choices: ['Normal', 'Cover', 'Contain'].map(label => ({
        label,
        value: label.toUpperCase(),
      })),
      block: true,
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotMedia, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
